import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider.jsx'

export default function PrivateRoute({ children }) {
  const { ready, session } = useAuth()
  const location = useLocation()

  if (!ready) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-brand-900">
        <div className="text-center">
          <div className="mb-4 h-8 w-8 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
          <p className="text-sm text-white/70">Carregando...</p>
        </div>
      </div>
    )
  }

  if (!session) return <Navigate to="/login" replace />
  if (session.isSuperAdmin && !session.empresaId && !session._impersonating && location.pathname !== '/super-admin') {
    return <Navigate to="/super-admin" replace />
  }
  return children
}
